import { useContentSelector } from '@wajeez-web/stores/content';

export const useGetBadgesLookups = () => {
  return useContentSelector(({ badges }) => badges.lookups);
};

export const useCreateBadge = () => {
  return useContentSelector(({ badges }) => badges.create);
};
